import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [AuthGuard],
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'auth-action',
    loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./home/home.routes').then((m) => m.HOME_ROUTES),
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: '404',
    loadComponent: () => import('./not-found/not-found').then((m) => m.NotFoundComponent),
  },
  { path: '**', redirectTo: '404' },
];
